import React, { useRef } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const CountryInfo = ({
  data,
}) => {

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const {
    ref: statsRef,
    inView: statsInView
  } = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  return (
    <>
      <section className="mining-cards country-info">
        <div className="container">


          <div className="mining-cards-slider">

            {/* PREV ARROW */}
           {/* <div
              ref={prevRef}
              className="custom-arrow prev-arrow"
            >

              <motion.span
                initial={{
                  opacity: 0,
                  x: -20
                }}
                whileInView={{
                  opacity: 1,
                  x: 0
                }}
                transition={{
                  duration: 0.6
                }}
                whileHover={{
                  scale: 1.1
                }}
              >
                &#10094;
              </motion.span>

            </div>

            {/* NEXT ARROW
            <div
              ref={nextRef}
              className="custom-arrow next-arrow"
            >

              <motion.span
                initial={{
                  opacity: 0,
                  x: 20
                }}
                whileInView={{
                  opacity: 1,
                  x: 0
                }}
                transition={{
                  duration: 0.6
                }}
                whileHover={{
                  scale: 1.1
                }}
              >
                &#10095;
              </motion.span>

            </div>*/}

            {/* SWIPER */}
            <Swiper
              modules={[
                Navigation,
                Pagination
              ]}
              slidesPerView={1}
              loop={true}
              onBeforeInit={(swiper) => {

                swiper.params.navigation.prevEl =
                  prevRef.current;

                swiper.params.navigation.nextEl =
                  nextRef.current;

              }}
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current
              }}
              pagination={{
                clickable: true,
                el: ".mining-pagination"
              }}
              className="mining-swiper"
            >

              {data.map((item, index) => (

                <SwiperSlide key={index}>

                  <motion.div
                    className="mining-slide"
                    initial={{
                      opacity: 0,
                      scale: 0.98
                    }}
                    whileInView={{
                      opacity: 1,
                      scale: 1
                    }}
                    viewport={{
                      once: true
                    }}
                    transition={{
                      duration: 0.7
                    }}
                  >

                    {/* IMAGE */}
                    <div className="mining-image">

                      <motion.img
                        src={item.img}
                        alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}
                        initial={{
                          scale: 1.05
                        }}
                        whileInView={{
                          scale: 1
                        }}
                        transition={{
                          duration: 1.2
                        }}
                      />

                    </div>

                    {/* CONTENT CARD */}
                    <motion.div
                      className="mining-card"
                      initial={{
                        opacity: 0,
                        y: 30
                      }}
                      whileInView={{
                        opacity: 1,
                        y: 0
                      }}
                      transition={{
                        delay: 0.2,
                        duration: 0.6
                      }}
                    >

                      <div className="mining-card-inner">

    <h3>{item.title.toUpperCase()}</h3>

    <p className="section-text">
      {item.desc}
    </p>

     {item.stats && item.stats.length > 0 && (
  <motion.div
    className="who-stats"
    ref={statsRef}
    variants={staggerContainer}
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.3
    }}
  >
    {item.stats && item.stats.length > 0 && (
  <motion.div
    className="who-stats"
    ref={statsRef}
    variants={staggerContainer}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
  >
    {item.stats.map((stat, i) => (
      <motion.div
        key={i}
        className="who-stat"
        variants={fadeUp}
      >
        <h3>
          {statsInView && (
            <CountUp
              end={stat.number}
              duration={3}
            />
          )}
          {stat.suffix}
        </h3>

        <p className="section-text">
          {stat.text}
        </p>
      </motion.div>
    ))}
  </motion.div>
)}
  </motion.div>
)}
  </div>

                    </motion.div>

                  </motion.div>

                </SwiperSlide>

              ))}

            </Swiper>

            {/* PAGINATION */}
            <motion.div
              className="mining-pagination"
              initial={{
                opacity: 0
              }}
              whileInView={{
                opacity: 1
              }}
              transition={{
                delay: 0.4
              }}
            />

          </div>

        </div>
      </section>
    </>
  );
};

export default CountryInfo;